var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isHomePage() && _vm.$router.currentRoute.name)?_c('search'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('TheHeader'),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{},[_c('nuxt')],1),_vm._v(" "),_c('TheFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }